<script>
    export let mainText;
    export let subText;
</script>

<div class="row py-lg-5">
    <div class="col-lg-6 col-md-8 mx-auto">
      <h1 class="fw-light">{mainText}</h1>
      <p class="lead text-muted">{subText}</p>
    </div>
</div>

<style>
  .row {
    text-align: center;
    padding-top: 30px !important;
    padding-bottom: 20px !important;
  }
</style>